// Vendor
import { ElementRef, Renderer2 } from '@angular/core';
import Highcharts from 'highcharts/highstock';
// Constants
import { HIGHCHARTS_ESG_POS_NEG_DEFAULT_OPTIONS, NODATA_CLASS, NODATA_DEFAULT_MESSAGE } from './constants';
import * as i0 from "@angular/core";
export class EsgPosNegChartComponent {
    constructor(eltRef, renderer) {
        this.eltRef = eltRef;
        this.renderer = renderer;
        this.noDataMessage = NODATA_DEFAULT_MESSAGE;
        const chartDataJson = this.eltRef.nativeElement.getAttribute('chartDataJson');
        if (typeof chartDataJson !== 'undefined' && chartDataJson !== null)
            this.chartData = JSON.parse(chartDataJson);
    }
    ngOnInit() {
        this.highchartOptions = HIGHCHARTS_ESG_POS_NEG_DEFAULT_OPTIONS;
        this.renderElement = this.eltRef.nativeElement.parentElement;
        if (typeof this.chartData !== 'undefined' && this.chartData !== null) {
            this.renderChart(this.chartData);
        }
        else {
            this.displayNoData();
        }
    }
    renderChart(chartData) {
        const data = chartData.chart_data.map((item) => {
            if ((item.y ?? 0) <= 0) {
                const nulledItem = item;
                nulledItem.y = null;
                return nulledItem;
            }
            return item;
        });
        if (!data) {
            this.displayNoData();
        }
        else {
            this.hideNoData();
            this.highchartOptions.series[0].data = data;
            new Highcharts.Chart(this.renderElement, this.highchartOptions); // eslint-disable-line no-new
        }
    }
    displayNoData() {
        // Remove chartData so that if the chart wasn't cleaned up nicely,
        // it doesn't reappear
        this.renderer.addClass(this.eltRef.nativeElement, NODATA_CLASS);
        this.renderer.setProperty(this.eltRef.nativeElement, 'innerHTML', this.noDataMessage);
    }
    hideNoData() {
        this.renderer.removeClass(this.eltRef.nativeElement, NODATA_CLASS);
        this.renderer.setProperty(this.eltRef.nativeElement, 'innerHTML', '');
    }
}
EsgPosNegChartComponent.ɵfac = function EsgPosNegChartComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || EsgPosNegChartComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2)); };
EsgPosNegChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EsgPosNegChartComponent, selectors: [["ycn-esg-pos-neg-chart"]], standalone: false, decls: 0, vars: 0, template: function EsgPosNegChartComponent_Template(rf, ctx) { }, encapsulation: 2 });
